import * as stylex from '@stylexjs/stylex';
import { styles } from './scrim.styles';
interface ScrimProps {
  show: boolean;
  onClick?: (() => void) | undefined;
  level?: 'modal' | 'confirm';
}
export function Scrim({
  show,
  onClick,
  level = 'modal'
}: ScrimProps) {
  return <div {...stylex.props(styles.scrim, level === 'confirm' && styles.confirm, show && styles.show)} onClick={onClick} />;
}